import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { TextField } from "@mui/material";
import "./green-datepicker.css";

function CustomInput({ onFocus, value, onChange, label, error }) {
  return (
    <TextField
      label={label}
      onFocus={onFocus}
      value={value}
      onChange={onChange}
      error={error}
      helperText={error}
      fullWidth
      readOnly
    />
  )
}

function Datepicker({ onChange, label, error }) {
  return (
    <DatePicker
      format="HH:mm:ss YYYY/MM/DD"
      plugins={[
        <TimePicker position="bottom" />
      ]}
      render={<CustomInput label={label} error={error} />}
      calendar={persian}
      locale={persian_fa}
      calendarPosition="bottom"
      onChange={onChange}
      inputClass="date-picker-input"
      className="green"
    />
  );
}

export default Datepicker;
